export const getSettingValue = (currentValue, defaultValue) => {
  let settingValue;
  if (currentValue === undefined || currentValue === null) {
    settingValue = defaultValue;
  } else {
    settingValue = currentValue;
  }
  return settingValue;
};
